import { useCallback, useState } from "react";
import { dealerApi } from "../services/dealer.api";

export const useExportDealers = () => {
  const [isExporting, setIsExporting] = useState(false);

  const handleExport = useCallback(async () => {
    setIsExporting(true);
    try {
      const blob = await dealerApi.exportData();
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.download = "distribuidores_teethtab.xlsx";
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
    } finally {
      setIsExporting(false);
    }
  }, []);

  return { handleExport, isExporting };
};
